export const appraisersMiddleware =
  (store: any) => (next: any) => (action: any) => {
    return next(action);
  };
